(() => {
  const bannerSelector = "[data-cart-banner]";
  const formSelector = "[data-banner-form]";
  const addSelector = "[data-banner-add]";
  const removeSelector = "[data-banner-remove]";
  const statusSelector = "[data-banner-status]";

  const cartDrawer = document.querySelector("cart-drawer");

  const getSections = () => {
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== "function") {
      return [];
    }
    return cartDrawer.getSectionsToRender().map((section) => section.id);
  };

  const refreshCart = (parsedState) => {
    if (!cartDrawer || typeof cartDrawer.renderContents !== "function") return;
    cartDrawer.renderContents(parsedState, false);
  };

  const showLoader = () => {
    const loader = document.querySelector(".wt-cart__loader");
    if (loader) {
      loader.classList.add("is-visible", "wt-cart__loader--updating");
      loader.setAttribute("aria-hidden", "false");
    }
    const items = document.getElementById("CartDrawer-CartItems");
    if (items) items.classList.add("cart__items--disabled");
  };

  const hideLoader = () => {
    const loader = document.querySelector(".wt-cart__loader");
    if (loader) {
      loader.classList.remove("is-visible", "wt-cart__loader--updating");
      loader.setAttribute("aria-hidden", "true");
    }
    const items = document.getElementById("CartDrawer-CartItems");
    if (items) items.classList.remove("cart__items--disabled");
  };

  const toggleHiddenClass = (element, shouldHide) => {
    if (!element) return;
    element.classList.toggle("hidden", Boolean(shouldHide));
  };

  const setStatus = (banner, message) => {
    const status = banner.querySelector(statusSelector);
    if (!status) return;
    if (message) {
      status.textContent = message;
      toggleHiddenClass(status, false);
    } else {
      status.textContent = "";
      toggleHiddenClass(status, true);
    }
  };

  const setButtonState = (button, loading) => {
    if (!button) return;
    if (loading) {
      button.setAttribute("aria-disabled", "true");
      button.classList.add("is-loading");
    } else {
      button.removeAttribute("aria-disabled");
      button.classList.remove("is-loading");
    }
  };

  const handleAdd = (event) => {
    const form = event.target.closest(formSelector);
    if (!form) return;
    const banner = form.closest(bannerSelector);
    if (!banner) return;

    event.preventDefault();
    const submitButton = form.querySelector(addSelector);
    if (submitButton?.getAttribute("aria-disabled") === "true") return;

    setStatus(banner, "");
    setButtonState(submitButton, true);

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(form);
    const sections = getSections();
    if (sections.length) {
      formData.append("sections", sections);
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const errorMessage =
            response.errors || response.description || response.message;
          setStatus(banner, errorMessage);
          return;
        }

        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-banner",
            productVariantId: formData.get("id"),
            cartData: response,
          });
        }

        refreshCart(response);
      })
      .catch((error) => {
        console.error("[cart-banner] add error", error);
        setStatus(banner, window.cartStrings?.error || "Error");
      })
      .finally(() => {
        setButtonState(submitButton, false);
      });
  };

  const handleRemove = (event) => {
    const removeBtn = event.target.closest(removeSelector);
    if (!removeBtn) return;
    const banner = removeBtn.closest(bannerSelector);
    if (!banner) return;

    event.preventDefault();

    const lineIndex = parseInt(banner.dataset.lineIndex || "0", 10);
    const lineKey = banner.dataset.lineKey;
    if (!lineIndex && !lineKey) return;

    setStatus(banner, "");
    removeBtn.setAttribute("aria-disabled", "true");

    const sections = getSections();
    const payload = {
      quantity: 0,
      sections,
      sections_url: window.location.pathname,
    };

    if (lineIndex) {
      payload.line = lineIndex;
    } else if (lineKey) {
      payload.id = lineKey;
    }

    const body = JSON.stringify(payload);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          setStatus(banner, parsedState.errors);
          return;
        }

        if (typeof publish === "function") {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-banner",
            productVariantId: banner.dataset.variantId,
            cartData: parsedState,
          });
        }

        refreshCart(parsedState);
      })
      .catch((error) => {
        console.error("[cart-banner] remove error", error);
        setStatus(banner, window.cartStrings?.error || "Error");
      })
      .finally(() => {
        removeBtn.removeAttribute("aria-disabled");
      });
  };

  const checkboxSelector = "[data-banner-checkbox]";

  const handleCheckboxChange = (event) => {
    const checkbox = event.target;
    if (!checkbox.matches(checkboxSelector)) return;
    const item = checkbox.closest(bannerSelector);
    if (!item) return;

    const variantId = item.dataset.variantId;
    if (!variantId) return;

    checkbox.disabled = true;
    showLoader();

    if (checkbox.checked) {
      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", "1");
      const sections = getSections();
      if (sections.length) {
        formData.append("sections", sections);
        formData.append("sections_url", window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            checkbox.checked = false;
            return;
          }
          if (typeof publish === "function") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-banner",
              productVariantId: variantId,
              cartData: response,
            });
          }
          refreshCart(response);
        })
        .catch((error) => {
          console.error("[cart-banner] checkbox add error", error);
          checkbox.checked = false;
        })
        .finally(() => {
          checkbox.disabled = false;
          hideLoader();
        });
    } else {
      const lineKey = item.dataset.lineKey;
      const lineIndex = parseInt(item.dataset.lineIndex || "0", 10);
      if (!lineIndex && !lineKey) {
        checkbox.checked = true;
        checkbox.disabled = false;
        hideLoader();
        return;
      }

      const sections = getSections();
      const payload = {
        quantity: 0,
        sections,
        sections_url: window.location.pathname,
      };
      if (lineIndex) payload.line = lineIndex;
      else if (lineKey) payload.id = lineKey;

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body: JSON.stringify(payload) } })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.errors) {
            checkbox.checked = true;
            return;
          }
          if (typeof publish === "function") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-banner",
              productVariantId: variantId,
              cartData: parsedState,
            });
          }
          refreshCart(parsedState);
        })
        .catch((error) => {
          console.error("[cart-banner] checkbox remove error", error);
          checkbox.checked = true;
        })
        .finally(() => {
          checkbox.disabled = false;
          hideLoader();
        });
    }
  };

  document.addEventListener("submit", handleAdd);
  document.addEventListener("click", handleRemove);
  document.addEventListener("change", handleCheckboxChange);
})();
